import { Outlet } from "react-router-dom";

export default function FIFO() {
  return <Outlet />;
}
